import React from 'react';

import { FormProvider, useForm } from 'react-hook-form';
import { observer } from 'mobx-react';
import { enqueueSnackbar } from 'notistack';

import { YesNoBtnRow } from '@infoods/lifebase-ui';

import classes from './NgzBusinessInfoTab.module.scss';
import { angularizeWithProviders } from '../../../../../shared/providers';
import { loggedInUserDataStore } from '../../../../../shared/stores/loggedInUserDataStore';
import {
  EntityBusinessInfoFromValue,
  EntityBusinessInfoInputs,
} from '../../../../components/EntityBusinessInfoInputs/EntityBusinessInfoInputs';
import { entityService } from '../../../../services/entityService';
import { getEntityBusinessInfoFormValue } from './utils/getEntityBusinessInfoFormValue';

type NgzBusinessInfoTabProps = {
  entityId: string;
};

const NgzBusinessInfoTab = observer(({ entityId }: NgzBusinessInfoTabProps) => {
  const { isInbodyAdmin } = loggedInUserDataStore;

  const formMethods = useForm<EntityBusinessInfoFromValue>({
    defaultValues: async () => getEntityBusinessInfoFormValue(entityId),
  });
  const { handleSubmit, formState } = formMethods;

  const handleFormSubmit = handleSubmit(async ({ businessInfo }) => {
    await entityService.updateEntityBusinessInfo(entityId, businessInfo);
    enqueueSnackbar('Business info updated', { variant: 'success' });
  });

  return (
    <>
      <FormProvider {...formMethods}>
        <EntityBusinessInfoInputs mode={isInbodyAdmin ? 'VIEW' : 'EDIT'} />
      </FormProvider>
      {!isInbodyAdmin && (
        <YesNoBtnRow
          yesText="Save"
          yesHandler={handleFormSubmit}
          className={classes.buttonRow}
          yesDisabled={!formState.isDirty}
        />
      )}
    </>
  );
});

angularizeWithProviders(NgzBusinessInfoTab, 'ngzBusinessInfoTab', { entityId: '<' });
